import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import './Resultats.css';

import accredhospilogo from '../../assets/images/accredhospi-logo.png'
import { connect } from 'react-redux';
import { SET_REFERENTIEL } from '../../state/action/action';
//import theLogo from './accredhospi-logo.png';

const useStyles = makeStyles((theme) =>({
	btn: {
      '& .MuiButton-label' :{
          textTransform :'none',
					fontWeight: 'bold',
					fontSize: '16px'
      }
  }
}));

const evaluateRapport = (eltLength, val) => {
	return Math.trunc((val / eltLength) * 100);
}

const stringRapport = (len, val) => {
	let rap = evaluateRapport(len, val);
	return `${val}/${len} (${rap}%)`
}

const numberOfCritereRel = (objectVal) => {
	let numCritere = 0;
	objectVal.references.forEach(ref => {
		numCritere += ref.criteres.length;
	});

	return numCritere
}

const numberOfCritereDom = (objectVal) => {
	let numCritere = 0;
	objectVal.referentiel.forEach(rel => {
		numCritere += numberOfCritereRel(rel);
	});

	return numCritere;
}

const appreciationssCr = (value) => {
	if (value == 0) return 'Mauvais';
	if (value == 1) return 'Bon';
}

const appreciationCr = (value) => {
	if (value == 0) return 'Mauvais';
	if (value == 0.5) return 'Moyen';
	if (value == 1) return 'Bon';
}


const styleAppreciationCr = (value) => {
	if (value == 0) return 'insuffisanteCr';
	if (value == 0.5) return 'bonneCr';
	if (value == 1) return 'excellenteCr';
}

const appreciationRefRelDom = (value) => {
	if (value >= 80) return 'Excellent';
	if (value >= 60 && value < 80) return 'Bon';
	if (value >= 40 && value < 60) return 'Insuffisant';
	if (value < 40) return 'Très insuffisant';
}


const styleAppreciationRefRelDom = (value) => {
	if (value >= 80) return 'excellente';
	if (value >= 60 && value < 80) return 'bonne';
	if (value >= 40 && value < 60) return 'insuffisante';
	if (value < 40) return 'tresinsuffisante';
}

let GLOBAL; 

function Resultats({referentiels, information, dispatch}) {
	const [referentielData, setReferentielData] = useState(referentiels)
	const classes = useStyles();
/* 
	useEffect(() => {
		fetchJson();
	}, [])
 */
	const setReferentiel = (value) => {
			const action = {
				type: SET_REFERENTIEL,
				value
			};
			dispatch(action)
	}

	const fetchJson = async () => {
		try {
			const jsonFile = await fetch('./data/domaine/management/referentiel.json');
			const res = await jsonFile.json();

			const cloneRef = JSON.parse(JSON.stringify(res));
			
			console.log(cloneRef)
			
			setReferentielData(cloneRef)
			setReferentiel(cloneRef);
		} catch (err) {
			console.log(`Err: ${err}`);
		}
	}

	const reinitialiseData = async () => {
		fetchJson();
	}

	const rowTable = (key, val1, val2, val3, style, appStyle) => {
		return (
			<tr key={key} className={style}>
				<td>{val1}</td>
				<td>{val2}</td>
				<td className={appStyle}>{val3}</td>
			</tr>
		)
	}

	const customRowTable = (key, val1, val2, val3, style, appStyle, funRow, param) => {
		return(
			<>
				{rowTable(key, val1, val2, val3, style, appStyle)}
				{funRow(param)}
			</>
		)
	}

	const ssCritere = (ssCritere) => {
		return (
			ssCritere.map((ssCr, index) => rowTable(`ssCr-${index}`, `- ${ssCr.description}`, `${ssCr.note == 1 ? 'Oui' : 'Non'}`, `${appreciationssCr(ssCr.note)}`, 'sous_critere', ''))
		)
	}

	const createCritere = (critereArray) => {
		return (
			critereArray.map(cr => {
				//let rap = evaluateRapport(cr.sous_criteres.length, cr.note);
				let note = stringRapport(cr.sous_criteres.length, cr.note);
				return(customRowTable(
				`cr-${cr.pos}`,
				`Critere ${cr.pos}: ${cr.titre}`,
				cr.note, 
				appreciationCr(cr.note),
				'critere',
				styleAppreciationCr(cr.note),
				ssCritere,
				cr.sous_criteres
				))})
		)
	} 

	const createReference = (refArray) => {
		return (
			refArray.map(ref => {
				let rap = evaluateRapport(ref.criteres.length, ref.note);
				let note = stringRapport(ref.criteres.length, ref.note);
				return(customRowTable(
				`ref-${ref.pos}`,
				`Reference ${ref.pos}: ${ref.titre}`,
				note, 
				appreciationRefRelDom(rap),
				'reference',
				styleAppreciationRefRelDom(rap),
				createCritere,
				ref.criteres
				))})
		)
	}

	const createReferentiel = (relArray) => {
		return (
			relArray.map(rel => {
				let crLen = numberOfCritereRel(rel);
				let rap = evaluateRapport(crLen, rel.note);
				let note = stringRapport(crLen, rel.note);
				return(customRowTable(
				`rel-${rel.pos}`,
				`Referentiel ${rel.pos}: ${rel.titre}`,
				note, 
				appreciationRefRelDom(rap),
				'referentiel',
				styleAppreciationRefRelDom(rap),
				createReference,
				rel.references
				))})
		)
	}

	const createDomaine = (domaine) => {
		let crLen = numberOfCritereDom(domaine);
		let rap = evaluateRapport(crLen, domaine.note);
		let note = stringRapport(crLen, domaine.note);
		return (
			customRowTable(
				`dom- ${domaine.pos}`, 
				`Domaine ${domaine.pos}: ${domaine.titre}`,
				note, 
				appreciationRefRelDom(rap),
				'domaine',
				styleAppreciationRefRelDom(rap),
				createReferentiel,
				domaine.referentiel)
		)
	}

  return (
	<div>
		<Grid container alignItems='center' justify='center' direction='column'>
			{/* <Button variant='contained' color='secondary' style={{marginBottom: '2%'}}>
				Réinitialiser les données
			</Button>
 */}
			<button className='reinitialiser-btn' onClick={reinitialiseData}>
				Réinitialiser les données d'évaluation
			</button>

			<ReactHTMLTableToExcel
											id="test-table-xls-button"
											className="download-table-xls-button"
											table="table-to-xls"
											filename="tablexls"
											sheet="tablexls"
											buttonText="Téléchager comme .xls"/>
		</Grid>
		<table id='table-to-xls'>
			<tbody>
				{/* <tr>
					<td>
						Résultats de l'évaluation faites grace à la plateforme accredhospibenin (acredhospi-benin.com)
					</td>
					<td>
						<img src={accredhospilogo} alt="logo" style={{width: '105px', height: '90px'}} />
					</td>
				</tr> */}
				<tr className="entete">
					<th>Résultats de l'évaluation</th>
					<th>
						<Button href='https://www.accredhospi-benin.com/' className={classes.btn}>
							www.accredhospi-benin.com
						</Button>
					</th>
					<th>
						<img src={accredhospilogo}  alt='Logo' style={{width: '105px', height: '90px'}} />
					</th>
				</tr>
				<tr>
					<th>Structures</th>
					<th>Identifiants</th>
					<th>Mail</th>
				</tr>
				{rowTable("hosto-info", "Hôpital", "Nom: "+information.hname+ " - Autorisations: "+information.hautorisation+ " - Numéro: "+ information.hnum , information.hmail)}
				{rowTable("user-info", `Agent (${information.userstatus == 1 ? 'Audit interne' : 'Evaluation externe'})`, `Nom: ${information.username} - Fonction: ${information.fonction}`, information.usermail)}
				
				<tr>
					<th>Rubriques</th>
					<th>Valeur</th>
					<th>Observations</th>
				</tr>
				{rowTable('Note-gen', 'Note générale', stringRapport(numberOfCritereDom(referentielData.domaine), referentielData.domaine.note), '', 'generale', '')}
				{createDomaine(referentielData.domaine)}
			</tbody>
		</table>
	</div>
	)
}

const mapStateToProps = (state) => {
	return {
		referentiels: state.setReferentielReducer.referentiel,
		information: state.setInfosReducer.infos
	}
}

export default connect(mapStateToProps)(Resultats);
